import React, { useEffect, useState } from "react";
import {Form, ProgressBar } from "react-bootstrap";
import { BsClockHistory } from "react-icons/bs";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import { useParams } from "react-router";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const CompletionbyForm = ({dataType}) => {
  const [formLoading, setFormLoading] = useState(false);
  const [formStats, setFormStats] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getCompletionByMedicalReviewForm = async () => {
    setFormLoading(true)
    let data = await studyMedicalReviewServices.getCompletionByMedicalReviewForm(studyId, "ALL", dataType, StudyMode)
    setFormStats(data?.data || [])
    setFormLoading(false)
  }

  useEffect(() => {
    getCompletionByMedicalReviewForm();
  }, [studyId, dataType]);
  return (
    <>
      {formLoading ?
        <PageLoader />
        :
        <div className="app-card shadow-md border br3 bg-light ">
          <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
            <Form.Label className="m-0 text-nowrap bold">
              <BsClockHistory className="me-2 text-info" /> Completion by Form
            </Form.Label>
            <small className="text-secondary">Top forms</small>
          </div>
          <div className="p-2 overflow-auto" style={{ height: 180 }}>
            {formStats?.map((item, index) => (
              <div className=" mb-3">
                <div className="hstack justify-content-between">
                  <Form.Label className="m-0 text-nowrap bold">{item?.formName}</Form.Label>
                  <span className="text-secondary">{item?.totalReviewedForm}/{item?.totalForm} reviewed</span>
                </div>
                <ProgressBar style={{ height: 8 }} variant="warning" now={item?.progressForm} />
              </div>
            ))}
          </div>
        </div>
      }
    </>
  );
};

export default CompletionbyForm;
